// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-item+.nav-item[data-v-ac7626f6]{margin-left:.5rem}", "",{"version":3,"sources":["webpack://./resources/assets/js/plugins/vuetable2-checkbox/components/header-action.vue"],"names":[],"mappings":"AACA,qCACI,iBAAA","sourcesContent":["\n.nav-item + .nav-item {\n    margin-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
